/*
 * rheincool — PDP-Anker-Navigation mit Scrollspy (Produktdetail-Handoff §7)
 *
 * Jeder Link zielt per data-target-class auf die Wrapper-Klasse seiner
 * Section. Fehlt das Ziel (Section nicht im Template oder leer gerendert),
 * wird der Link entfernt; ohne Links bleibt die Leiste versteckt.
 * Scrollspy: IntersectionObserver markiert den aktiven Abschnitt.
 */
class RcAnchorNav extends HTMLElement {
  connectedCallback() {
    this.links = Array.from(this.querySelectorAll('[data-anchor-link]'));
    this.pairs = [];

    this.links.forEach((link) => {
      const target = document.querySelector(`.${link.dataset.targetClass}`);
      // Leere Wrapper (Section hat nichts gerendert) zählen nicht als Ziel
      if (!target || target.offsetHeight < 10) {
        link.remove();
        return;
      }
      this.pairs.push({ link, target });
      link.addEventListener('click', (event) => {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (this.pairs.length === 0) return;
    this.hidden = false;

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), {
        rootMargin: '-30% 0px -60% 0px',
      });
      this.pairs.forEach(({ target }) => this.observer.observe(target));
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      this.pairs.forEach(({ link, target }) => {
        link.classList.toggle('is-active', target === entry.target);
      });
    });
  }
}

customElements.define('rc-anchor-nav', RcAnchorNav);
